import { Component, HostListener, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { OrgsIndividualComponent } from './../orgs-individual/orgs-individual.component';
import { TeamReportServiceService } from '../team-report/team-report-service.service';
import { HttpService } from './../../http.service';
import { CommonDataService } from '../common-data.service';
import { LambdaFunctionService } from '../../service/lambda-function.service';
import { RosterServiceService } from '../org-individual-teams/roster-service.service';
import { OrgIndividualTeamsComponent } from '../org-individual-teams/org-individual-teams.component';
import { TeamManagementService } from '../org-individual-teams/team-management.service';
import { RosterMemberService } from '../org-individual-teams/roster-member.service';
import { RosterMemberOpsService } from '../org-individual-teams/roster-member-ops.service';
import { RosterModalService } from '../org-individual-teams/roster-modal.service';
import acme_roster_data from '../orgs/acme_roster.json';
import roster_members from '../orgs/acme_roster_members_name.json';

declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-acme-roster',
  templateUrl: './../org-individual-teams/org-individual-teams.component.html',
  styleUrls: ['./../org-individual-teams/org-individual-teams.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    RosterModalService,
    { provide: OrgIndividualTeamsComponent, useExisting: AcmeRosterComponent }
  ]
})
export class AcmeRosterComponent extends OrgIndividualTeamsComponent implements OnInit, OnDestroy {

  constructor(
    activatedRoute: ActivatedRoute,
    orgs: OrgsIndividualComponent,
    http: HttpClient,
    modalService: NgbModal,
    route: Router,
    teamReportService: TeamReportServiceService,
    httpService: HttpService,
    store: Store<any>,
    commonDataService: CommonDataService,
    lmbda_service: LambdaFunctionService,
    rosterService: RosterServiceService,
    teamManagementService: TeamManagementService,
    rosterMemberService: RosterMemberService,
    memberOpsService: RosterMemberOpsService
  ) {
    super(activatedRoute, orgs, http, modalService, route, teamReportService, httpService, store, commonDataService, lmbda_service, rosterService, teamManagementService, rosterMemberService, memberOpsService);
  }

  @HostListener('window:beforeunload', ['$event'])
  override handleBeforeUnload(event: BeforeUnloadEvent) {
    localStorage.setItem('acmeRosterLatestData', JSON.stringify(this.acme_roster));
    localStorage.setItem('acmeRosterMemberLatestData', JSON.stringify(this.acme_roster_members));
  }

  override async ngOnInit() {
    this.env = environment;
    this.id = '0000';
    (this.orgs as any).id = '0000';
    this.demo_roster_id = '0000';
    this.modalSvc.teamWizard = false;
    this.loading = true;
    this.totalMembers = localStorage.getItem('orgTotalMember');
    this.rosterName = localStorage.getItem('currentOrgName') || 'ACME SAMPLE ROSTER';
    this.loggedInUserEamil = localStorage.getItem('email');
    this.ngrxAccount = this.store.select<any>((state) => state.profile.account);
    this.ngrxAccount.subscribe(async (res) => {
      this.loginMemTeams = res['member']?.teams_names;
    });

    this.teamReportService.team_members.subscribe((res) => {
      if (res.length > 0) {
        this.teamMembers = res;
      }
    });

    // Load from localStorage if available, otherwise from JSON
    let latestAcmeRosterData = localStorage.getItem('acmeRosterLatestData');
    let latestAcmeRosterMbrData = localStorage.getItem('acmeRosterMemberLatestData');
    if (latestAcmeRosterData && latestAcmeRosterMbrData) {
      this.isLocalstorage = true;
      this.acme_roster = JSON.parse(latestAcmeRosterData);
      this.acme_roster_members = JSON.parse(latestAcmeRosterMbrData);
    } else {
      this.acme_roster = JSON.parse(JSON.stringify(acme_roster_data));
      this.acme_roster_members = JSON.parse(JSON.stringify(roster_members));
    }

    await this.getTeamsData();
    this.org_name = this.route.url;
    this.org_name = this.org_name.replace('/teams', '');
    this.org_name = this.org_name.replace('/orgs/', '');
    this.roasterMembers();
    this.getAllInvitation();
  }

  // Override getTeamsData - always use in-memory data, no API calls
  override getTeamsData() {
    this.allTeamIdsTtl = [];
    this.teams = this.acme_roster.teams;
    this.teamsMeta = { total_count: this.acme_roster.teams.length };
    this.team_name = this.acme_roster.name;
    this.team_id = this.acme_roster.id;
    this.teams.forEach((team) => {
      this.allTeamIdsTtl.push({
        teamId: team.id,
        showMember: this.defaultShowingMembers,
        teamName: team.name,
        memberships_count: team.memberships_count,
      });
    });
    for (var i = 0; i < this.teams.length; i++) {
      if (this.teams[i].name == 'Unassigned') {
        this.unassignedTeam = this.teams[i].id;
      } else {
        this.teams[i].memberships = this.sortTeamMembers(this.teams[i].memberships);
      }
    }
    localStorage.getItem('rosterDetailView') == 'hierar'
      ? this.hirerachicalData()
      : localStorage.getItem('rosterDetailView') == 'dirView'
      ? this.gridView('dirView')
      : this.gridView();
    this.loadingTeams = false;
  }

  // Override roasterMembers - always use in-memory data
  override roasterMembers(membersCount = 20, pageNo = 1) {
    this.currentPg = pageNo;
    this.loading = false;
    const users = Array.from(
      { length: this.acme_roster.members.length ? this.acme_roster.members.length : 19 },
      (_, i) => this.add_acme_memmbers(i + 1)
    );
    this.acme_roster.members = users;
    let item = document.querySelectorAll('.teammates__head th input[type="checkbox"]')[0] as HTMLInputElement;
    if (item && item.checked) {
      $('.teammates__head th input[type="checkbox"]').click();
    }
    this.teamsData = this.acme_roster;
    this.totalMembers = this.acme_roster.members.length;

    if (this.selectedRosterMembers) {
      this.teamsData.members.map((item) => {
        const match = this.selectedRosterMembers.find((obj) => obj.id === item.id);
        if (match) {
          item['checked'] = true;
        }
      });
    }
    if (this.gridHirView == 'hierar') {
      this.hirerachicalData();
    }
  }

  // Override searchTeam - client-side filter only
  override searchTeam(e) {
    if (e.which == 8 && this.teamSrchName?.length == 0) {
      this.getTeamsData();
    }
    if (this.teamSrchName.length > 2) {
      this.loading = true;
      this.acmeSearchTeam(this.teamSrchName).then((res: any) => {
        if (res?.length) {
          this.teams = res;
        } else {
          this.teams = [];
        }
        if (this.gridHirView == 'hierar') {
          this.hirerachicalData();
        }
        this.loading = false;
      });
    }
  }

  // Override cancelSrchTeam - no API calls
  override cancelSrchTeam() {
    if (this.teamSrchName?.length > 0) {
      this.getTeamsData();
      this.teamSrchName = '';
    }
  }

  // Override UpdateTeam - in-memory update
  override async UpdateTeam() {
    if (this.modalSvc.updatedTeamId) {
      this.acme_roster?.teams?.forEach((team) => {
        if (team.id == this.modalSvc.updatedTeamId) {
          team.name = this.modalSvc.temp;
        }
      });
      this.openCloseTeamPopup();
    }
  }

  // Override addTeam - in-memory push
  override async addTeam() {
    if (this.teamName) {
      this.loading = true;
      this.add_acme_Team(this.teamName, this.acme_roster.teams.length);
      setTimeout(() => {
        this.loading = false;
      }, 100);
    }
  }

  // Override deleteTeam - in-memory splice
  override async deleteTeam(id, index) {
    this.teams.forEach((tm, ind) => {
      if (tm.id == id) {
        index = ind;
        tm.memberships.forEach((mbr) => {
          this.teamsData.members.forEach((mem, rInd) => {
            if ((mbr.member_id && mbr.member_id == mem.id) || (mbr.id && mbr.id == mem.id)) {
              delete this.teamsData.members[rInd].teams_names[id];
              this.teamsData.members[rInd].non_admin_unassgined_teams_count -= 1;
            }
          });
        });
      }
    });
    this.teams.splice(index, 1);
    this.allTeamIdsTtl = [];
    this.teams.forEach((team) => {
      this.allTeamIdsTtl.push({
        teamId: team.id,
        showMember: this.defaultShowingMembers,
        teamName: team.name,
        memberships_count: team.memberships_count,
      });
    });

    if (this.gridHirView == 'hierar') {
      this.hirerachicalData();
    }
    Swal.fire({ title: 'Nice!', text: 'The Team was deleted successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
    $('.roster-del-mem').css('display', 'none');
    this.selectAll = false;
    this.selectAllRoaster(false);
  }

  // Override deleteSelectedTeams - in-memory bulk delete
  override deleteSelectedTeams(): void {
    const teams = [...this.slectedIndividualTeamArr];
    const count = teams.length;
    if (!count) return;
    Swal.fire({
      title: `Delete ${count} team${count > 1 ? 's' : ''}?`,
      text: `This will permanently delete ${count} selected team${count > 1 ? 's' : ''}. This cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      confirmButtonColor: '#d33',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (!result.isConfirmed) return;
      teams.forEach(team => {
        const idx = this.teams.findIndex(t => t.id === team.id);
        if (idx !== -1) {
          this.teams[idx].memberships.forEach((mbr: any) => {
            this.teamsData?.members?.forEach((mem: any, rInd: number) => {
              if (mbr.member_id === mem.id) {
                delete this.teamsData.members[rInd].teams_names[team.id];
                this.teamsData.members[rInd].non_admin_unassgined_teams_count -= 1;
              }
            });
          });
          this.teams.splice(idx, 1);
        }
      });
      this.rebuildAllTeamIdsTtl();
      if (this.gridHirView === 'hierar') { this.hirerachicalData(); }
      this.selectedGroupProfileTeamsArr = [];
      this.slectedIndividualTeamArr = [];
      Swal.fire({ title: 'Done!', text: `${count} team${count > 1 ? 's' : ''} deleted successfully.`, icon: 'success', timer: 2000, showConfirmButton: false });
    });
  }

  // Override searchRoaster - client-side filter only
  override async searchRoaster(value, showHide, clear = false) {
    this.filterInput = showHide;
    if (value !== '') this.clear = true;
    if (!value) this.filterData = '';
    if (clear) {
      setTimeout(() => {
        this.filterData = '';
        this.filterRoster = '';
        this.clear = false;
      }, 100);
    }
    if (value?.length > 2 && !clear) {
      this.rosterSearch = true;
      this.clear = false;
      this.acmeSearch(value).then((res: any) => {
        if (res?.length) {
          this.filterData = res;
          this.rosterSearch = false;
        } else {
          this.filterData = 'Member not Found';
          this.rosterSearch = false;
        }
      });
    } else {
      this.clear = true;
      this.rosterSearch = false;
    }
  }

  // Override sortRoaster - client-side sort only
  override async sortRoaster(sType: string, qType = 'last_name_order') {
    this.sortType = sType;
    this.queryType = qType;
    if (qType.includes('last_name')) {
      this.teamsData.members = this.rosterMemberService.sortByKey(this.teamsData.members, 'last_name', this.sortType as 'asc' | 'desc');
    } else {
      this.teamsData.members = this.rosterMemberService.sortByKey(this.teamsData.members, 'first_name', this.sortType as 'asc' | 'desc');
    }
  }

  // Override addTeamMembers - in-memory only
  override async addTeamMembers() {
    document.querySelector('body').classList.remove('oh');
    this.add_acme_member();
    this.loading = false;
  }

  // Override addRosterMemberInTeam - in-memory only
  override async addRosterMemberInTeam() {
    let data: any;
    if (
      (this.searchby == 'invitation' && this.modalSvc.selectedInvitation != 'Select Invitation') ||
      this.filterData
    ) {
      data = this.filterData;
      this.selectedFilterMbr.forEach((mbr, index) => {
        let itemExist = false;
        this.filterData.forEach((fmbr) => {
          if (mbr.id == fmbr.id) {
            itemExist = true;
          }
        });
        if (!itemExist) {
          data.push(mbr);
        }
      });
    } else if (this.selectedRosterMembers.length > 0) {
      data = this.selectedRosterMembers;
    } else {
      data = this.teamsData.members;
    }
    this.addAcmeRosterMemberToTeam(data);
    this.selectAll = false;
    this.selectAllRoaster(false);
    document.querySelector('body').classList.remove('oh');
  }

  // Override removeTeamMember - in-memory with ACME logic
  override async removeTeamMember(member) {
    let team;
    this.teams.forEach((t) => {
      t.memberships.forEach((m) => {
        if (m.id == member.id) {
          team = t;
        }
      });
    });
    if (team) {
      this.removeAcmeMember(team, member);
    }
  }

  // Override removedMember - in-memory only, no API call
  override async removedMember(member, teamId = '') {
    var that = this;
    let identity_id = member?.identity_id
      ? member?.identity_id
      : member.default_identity?.id
      ? member.default_identity.id
      : member.default_profile?.identity_id;
    this.allTeamIdsTtl = [];
    this.teams.forEach((team: any, index) => {
      team.memberships.forEach((mem: any, memIndex) => {
        if (identity_id == mem?.identity_id) {
          if (teamId) {
            delete mem?.teams_names?.[teamId];
          } else if (member?.team_id && member?.teams_names) {
            delete mem?.teams_names?.[member?.team_id];
          }
        }
        if (mem.id == member.id) {
          if (teamId && mem?.team_id == teamId) {
            this.teams[index].memberships.splice(memIndex, 1);
            if (this.teams[index].memberships_count) {
              this.teams[index].memberships_count -= 1;
            }
          } else if (!teamId && member?.team_id == team.id) {
            this.teams[index].memberships.splice(memIndex, 1);
            if (this.teams[index].memberships_count) {
              this.teams[index].memberships_count -= 1;
            }
          }
        }
      });
      this.allTeamIdsTtl.push({
        teamId: team.id,
        showMember: this.defaultShowingMembers,
        teamName: team.name,
        memberships_count: team.memberships_count,
      });
    });

    if (teamId) {
      delete that.modalSvc.membersDetails4NewTeam?.teams_names?.[teamId];
      that.teamsData.members.forEach((mem, ind) => {
        if (
          member?.member_id == mem?.id ||
          member?.id == mem?.id ||
          mem?.default_identity?.id == identity_id
        ) {
          that.teamsData.members[ind].non_admin_unassgined_teams_count -= 1;
          delete that.teamsData.members[ind].teams_names[teamId];
        }
      });
      if (this.filterData != '') {
        this.filterData.forEach((mem) => {
          if (identity_id == mem?.default_identity?.id) {
            mem.non_admin_unassgined_teams_count -= 1;
            delete mem.teams_names[teamId];
          }
        });
      }
    } else if (teamId == '') {
      that.teamsData.members.forEach((mem, ind) => {
        if (identity_id == mem?.default_identity?.id) {
          let tm_id = member?.team_id;
          delete that.teamsData.members[ind]?.teams_names[tm_id];
          that.teamsData.members[ind].non_admin_unassgined_teams_count -= 1;
        }
      });
      if (this.filterData != '') {
        this.filterData.forEach((mem) => {
          if (identity_id == mem?.default_identity?.id) {
            let tm_id = member?.team_id;
            mem.non_admin_unassgined_teams_count -= 1;
            delete mem.teams_names[tm_id];
          }
        });
      }
    }
    // No API call - just show success
    Swal.fire({ title: 'Nice!', text: 'The Member was removed successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
    this.modalSvc.addTeamPopup = false;
    this.modalSvc.membersDetails4NewTeam = null;
  }

  // Override removeRosterMem - in-memory only
  override removeRosterMem(record: any = '', oneOrMulti = 0, type = 'member', index = undefined) {
    this.modalSvc.remvoeTeamOrMem = type;
    this.modalSvc.removeRosterMemType = oneOrMulti;
    this.modalSvc.removeRosterMemDetails = record;
    this.teamReportService.rosterName.next(
      record?.default_identity?.first_name
        ? record?.default_identity?.first_name
        : record?.default_profile?.first_name
        ? record?.default_profile?.first_name
        : 'No name'
    );
    if (type === 'team') {
      this.modalSvc.removeTeamId = record.id;
      this.modalSvc.removeTeamIndex = index;
    }
    if (oneOrMulti == 1) {
      this.modalSvc.showRosterAddMemPopup = true;
    } else {
      this.modalSvc.showRosterDelMem = true;
    }
  }

  // Override gridView - no API calls for ACME
  override gridView(value = 'grid') {
    if (this.teamSrchName?.length && this.gridHirView !== value) {
      this.getTeamsData();
    }
    this.gridHirView = value;
    localStorage.setItem('rosterDetailView', value);
    this.teamSrchName = '';
    this.selectedGroupProfileTeamsArr = [];
    this.slectedIndividualTeamArr = [];
  }

  // Override participantView - no API needed for ACME
  override participantView(from, team, mbr: any = '') {
    let updateRoute = () => {
      if (from == 'team') {
        this.route.navigate(['/myteams', `${team.id}`]);
        localStorage.setItem('participantsTeamsAdmin', 'true');
      } else if (from == 'member') {
        localStorage.setItem('participantsTeamsAdmin', 'false');
        this.route.navigate([`/myteams/${team.id}/participant`, `${mbr?.member_id}`]);
      }
    };
    team['allMembers'] = team.memberships;
    const memberships_without_profile_countLength = team.allMembers.filter((mem) => mem.default_profile != null);
    team.memberships_without_profile_count = memberships_without_profile_countLength.length;
    this.teamReportService.participantTeamData = team;
    localStorage.setItem('participantTeamData', JSON.stringify(team));
    localStorage.setItem('participantData', JSON.stringify(mbr));
    updateRoute();
  }

  // Override updateCurrentPg - in-memory pagination
  override updateCurrentPg(pg) {
    this.teamMemberCurrentPg = pg;
    if (this.gridHirView == 'hierar') {
      this.hirerachicalData();
    }
  }

  // Override getSelInvMem - no invitations in demo mode
  override async getSelInvMem() {
    this.filterData = '';
  }

  // Override getAllInvitation - no API for ACME
  override async getAllInvitation() {
    if (this.filterRoster) {
      this.searchRoaster(this.filterRoster, true);
    } else {
      if (this.searchby !== 'invitation') {
        this.filterData = '';
      }
    }
  }

  // Override addNewTeamMate - no API for ACME
  override async addNewTeamMate() {
    Swal.fire({ title: 'Demo Mode', text: 'Adding new members by email is not available in demo mode.', icon: 'info', timer: 2000, showConfirmButton: false });
  }

  // Override searchMembers - no API for ACME
  override searchMembers(e) {
    // Client-side search not needed for ACME member view
  }

  // Override cancelSrchTeamMember - no API for ACME
  override cancelSrchTeamMember(id: any) {
    this.teamSrchName = '';
  }

  // Override selectedGroupProfileTeams - skip team_advice API call
  override selectedGroupProfileTeams(team) {
    const isCurrentlySelected = this.slectedIndividualTeamArr.some(item => item.id === team.id);
    this.rosterService.setGraphData(team).then(res => {
      const idx = this.selectedGroupProfileTeamsArr.findIndex(item => item.id === res.id);
      if (idx !== -1) {
        this.selectedGroupProfileTeamsArr.splice(idx, 1);
        const teamIdx = this.slectedIndividualTeamArr.findIndex(item => item.id === team.id);
        if (teamIdx !== -1) { this.slectedIndividualTeamArr.splice(teamIdx, 1); }
      } else {
        this.selectedGroupProfileTeamsArr.push(res);
        this.slectedIndividualTeamArr.push(team);
      }
    });
    this.rosterService.mockupTeamReport(team, true).then(args => {
      this.mockupReportArgs = args;
      if (isCurrentlySelected) {
        const idx = this.mockupReportArgsArr.findIndex(item => item.id === team.id);
        if (idx !== -1) { this.mockupReportArgsArr.splice(idx, 1); }
      } else {
        this.mockupReportArgsArr.push(args);
      }
    });
  }

  // ── ACME in-memory operations ─────────────────────────────────────────────

  override add_acme_memmbers(index: number) {
    if ((index == 1 || index == 3) && !this.isLocalstorage) {
      const acmeTeamId = index == 1 ? '0002' : '0004';
      const teamInd = this.acme_roster.teams.findIndex((obj) => obj.id === acmeTeamId);
      for (let i = 4; i < 9; i++) {
        const cloneData = JSON.parse(JSON.stringify(this.acme_roster_members[i]));
        this.acme_roster.teams[teamInd]['memberships'].push(cloneData);
      }
    }
    return this.acme_roster_members[index];
  }

  override async acmeSearchTeam(searchTerm) {
    const lower = searchTerm.toLowerCase();
    return this.acme_roster.teams.filter((team) => team?.name?.toLowerCase().includes(lower));
  }

  override async acmeSearch(searchTerm) {
    const lower = searchTerm.toLowerCase();
    return this.acme_roster.members.filter(
      (user) =>
        user?.first_name?.toLowerCase().includes(lower) ||
        user?.last_name?.toLowerCase().includes(lower) ||
        user?.email?.toLowerCase().includes(lower)
    );
  }

  override async add_acme_Team(teamName: string, index: number) {
    const data = {
      id: teamName + index,
      name: teamName,
      team_agreements: null,
      team_plan: null,
      my_plan: null,
      organization_id: '0000',
      organization_name: 'ACME SAMPLE ROSTER',
      memberships: [],
      memberships_count: 0,
      memberships_meta: { current_page: 1, next_page: null, prev_page: null, total_pages: 0, total_count: 0 },
      memberships_without_profile_count: 0,
    };
    this.acme_roster.teams.push(data);
    this.acme_roster.teams_count = this.acme_roster.teams.length;
    this.teams.sort(this.compareByName);
    this.teams.forEach((team) => {
      if (team.id == data.id && this.modalSvc.createNewTeamBtn) {
        team['checked'] = true;
      }
    });
    this.rebuildAllTeamIdsTtl();
    if (this.gridHirView === 'hierar') { this.hirerachicalData(); }
    this.selectedRosterMembers = [];
    this.modalSvc.showTeamModal = false;
    this.team_name = this.teamName;
  }

  override async delAcmeTeam(team: any) {
    Swal.fire({
      title: 'Remove Member!',
      text: `Are you sure, you want to remove ${team.name}  from ACME SAMPLE ROSTER?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '##D0D0D0',
      confirmButtonText: 'Yes, Remove it!',
    }).then(async (result) => {
      if (result['value'] == true) {
        const index = this.acme_roster.teams.findIndex((data: any) => data['id'] == team.id);
        if (index !== -1) {
          this.acme_roster.teams[index].memberships.forEach((mbr) => {
            this.teamsData.members.forEach((mem) => {
              if (mem.id == mbr.id) {
                delete mem.teams_names[team.id];
                mem.non_admin_unassgined_teams_count -= 1;
              }
            });
          });
          this.acme_roster.teams.splice(index, 1);
          this.acme_roster.teams_count = this.acme_roster.teams.length;
          Swal.fire({ title: 'Nice!', text: 'The Team was removed successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
          this.selectAll = false;
          this.selectAllRoaster(false);
        }
      }
    });
  }

  override removeAcmeMember(team, member) {
    Swal.fire({
      title: 'Remove Member!',
      text: `Are you sure, you want to remove ${member.first_name} ${member?.last_name || ''} from ${team.name}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '##D0D0D0',
      confirmButtonText: 'Yes, Remove it!',
    }).then(async (result) => {
      if (result['value'] == true) {
        this.teamsData?.members.forEach((mem) => {
          if (member.id == mem.id) {
            mem.non_admin_unassgined_teams_count -= 1;
            delete mem.teams_names[team.id];
          }
        });
        team.memberships.forEach((mem, memIndex) => {
          if (member.id == mem.id) {
            member.teams_count -= 1;
            team.memberships.splice(memIndex, 1);
            if (team?.memberships_count) { team.memberships_count -= 1; }
          }
        });
        Swal.fire({ title: 'Nice!', text: 'The Member was removed successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
        this.selectAll = false;
        this.selectAllRoaster(false);
      }
    });
  }

  override async addAcmeRosterMemberToTeam(data: any) {
    await this.teams.forEach(async (team, index) => {
      if (team.checked) {
        await data.forEach((mbr) => {
          if (mbr.checked) {
            mbr.teams_names[team.id] = team.name;
            const exists = team.memberships.some((mem) => mem.id === mbr.id);
            if (!exists) {
              mbr.non_admin_unassgined_teams_count += 1;
              mbr.teams_count += 1;
              team.memberships.push(mbr);
              team.memberships_count += 1;
            }
          }
        });
        team.checked = false;
      }
      this.allTeamIdsTtl.push({
        teamId: team.id,
        showMember: this.defaultShowingMembers,
        teamName: team.name,
        memberships_count: team.memberships_count,
      });
    });
    if (this.gridHirView === 'hierar') { this.hirerachicalData(); }
    Swal.fire({ title: 'Great!', text: 'Members are added successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
    this.modalSvc.addTeamPopup = false;
    this.selectedFilterMbr = [];
    this.modalSvc.membersDetails4NewTeam = null;
    this.selectedRosterMembers = [];
  }

  override async add_acme_member() {
    const mem4Team = this.modalSvc.membersDetails4NewTeam;
    const memberId = mem4Team?.id || mem4Team?.member_id;

    this.teams.forEach((team, index) => {
      if (team?.checked == true) {
        // Add member to team if not already present
        this.teamsData.members.forEach((mem, rInd) => {
          if (mem4Team?.id == mem?.id || mem4Team?.member_id == mem.id) {
            const alreadyInTeam = this.teams[index].memberships.some((m: any) => m.id === mem.id || m.member_id === mem.id);
            mem4Team.teams_names[team.id] = team.name;
            this.teamsData.members[rInd].teams_names[team.id] = team.name;
            if (!alreadyInTeam) {
              this.teams[index].memberships.push(mem4Team);
              this.teams[index].memberships_count = this.teams[index].memberships_count
                ? this.teams[index].memberships_count + 1 : 1;
              this.teamsData.members[rInd].non_admin_unassgined_teams_count += 1;
              this.teamsData.members[rInd].memberships += 1;
            }
            if (this.filterData) {
              this.filterData.forEach((fltrData, fltrInd) => {
                if (fltrData.default_identity?.id == mem.default_identity?.id) {
                  this.filterData[fltrInd] = mem;
                }
              });
            }
          }
        });
        team.checked = false;
      } else if (team?.checked === -1) {
        // Remove member from team (user unchecked a pre-selected team)
        const memIdx = this.teams[index].memberships.findIndex((m: any) => m.id === memberId || m.member_id === memberId);
        if (memIdx !== -1) {
          this.teams[index].memberships.splice(memIdx, 1);
          if (this.teams[index].memberships_count > 0) {
            this.teams[index].memberships_count -= 1;
          }
        }
        this.teamsData.members.forEach((mem, rInd) => {
          if (mem4Team?.id == mem?.id || mem4Team?.member_id == mem.id) {
            delete this.teamsData.members[rInd].teams_names[team.id];
            if (this.teamsData.members[rInd].non_admin_unassgined_teams_count > 0) {
              this.teamsData.members[rInd].non_admin_unassgined_teams_count -= 1;
            }
          }
        });
        team.checked = false;
      }
    });
    Swal.fire({ title: 'Great!', text: 'Members were updated successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
    this.modalSvc.addTeamPopup = false;
    this.modalSvc.addToTeamBtn = false;
    this.loading = false;
    if (this.gridHirView === 'hierar') { this.hirerachicalData(); }
  }

  override updateAcmeRosterTeamMemberFn(data: any) {
    this.acme_roster.members.map((e: any) => {
      if (data?.membership_id == e.id) {
        e.first_name = data.first_name;
        e.last_name = data.last_name;
      }
    });
    Swal.fire({ title: 'Nice!', text: 'Members Updated Successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
    this.loading = false;
    this.modalSvc.showRosterAddMemPopup = false;
    this.modalSvc.showRosterEditMemPopup = false;
  }

  override deleteAcmeRosterTeamMemberFn(data: any) {
    const index = this.acme_roster.members.findIndex((e: any) => data?.id == e.id);
    this.acme_roster.members.splice(index, 1);
    // cascade: scan all teams directly — teams_names is empty for many ACME members
    this.teams.forEach((team: any) => {
      if (!team.memberships?.length) return;
      const before = team.memberships.length;
      // filter returns a new array reference so Angular *ngFor detects the change
      team.memberships = team.memberships.filter((mbr: any) =>
        String(mbr.member_id) !== String(data.id) && String(mbr.id) !== String(data.id)
      );
      if (team.memberships.length < before && team.memberships_count > 0) {
        team.memberships_count -= 1;
      }
    });
    this.modalSvc.showRosterAddMemPopup = false;
    this.modalSvc.showRosterDelMem = false;
    this.acme_roster.members_count = this.acme_roster.members.length;
    this.totalMembers = this.acme_roster?.members?.length;
    this.loading = false;
    this.getTeamsData();
    Swal.fire({ title: 'Nice!', text: 'Member deleted successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
  }

  override addAcmeRosterTeamMemberFn(data: any) {
    let lastId = this.acme_roster.members[this.acme_roster.members.length - 1]?.id || 0;
    data.members_attributes.forEach((e: any) => {
      lastId++;
      this.acme_roster.members.push({ id: lastId, email: e.email, first_name: '', last_name: '' });
    });
    this.acme_roster.members_count = this.acme_roster.members.length;
    this.totalMembers = this.acme_roster?.members?.length;
    this.modalSvc.showRosterAddMemPopup = false;
    this.loading = false;
    Swal.fire({ title: 'Nice!', text: 'Members Added Successfully!', icon: 'success', timer: 2000, showConfirmButton: false });
  }
}
